var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "#E5FAEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.375 16.375H14.625C14.141 16.375 13.75 16.766 13.75 17.25V34.75C13.75 35.234 14.141 35.625 14.625 35.625H37.375C37.859 35.625 38.25 35.234 38.25 34.75V17.25C38.25 16.766 37.859 16.375 37.375 16.375ZM35.1656 19.3527L26.5387 26.0656C26.3254 26.2324 26.0273 26.2324 25.8141 26.0656L17.1844 19.3527C17.1518 19.3276 17.128 19.293 17.1161 19.2536C17.1043 19.2143 17.1051 19.1722 17.1183 19.1333C17.1316 19.0944 17.1567 19.0607 17.1901 19.0368C17.2235 19.0128 17.2636 19 17.3047 19H35.0453C35.0864 19 35.1265 19.0128 35.1599 19.0368C35.1933 19.0607 35.2184 19.0944 35.2317 19.1333C35.2449 19.1722 35.2457 19.2143 35.2339 19.2536C35.222 19.293 35.1982 19.3276 35.1656 19.3527Z",
    fill: "#0D9F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.4e6bdf980affc69ad8fc581b0be709dd.svg";
export { ForwardRef as ReactComponent };